"use client";

import { useState } from "react";
import { NavUtils } from "./nav-utils";

export function LinksContainer({
  links,
  isCollapsed = false,
}: {
  links: any[];
  isCollapsed?: boolean;
}) {
  const [openDropdowns, setOpenDropdowns] = useState<string[]>([]);

  const toggleDropdown = (linkName: string) => {
    setOpenDropdowns((prev) =>
      prev.includes(linkName)
        ? prev.filter((name) => name !== linkName)
        : [...prev, linkName],
    );
  };

  return (
    <div className="flex flex-col justify-center items-start gap-4 w-full">
      {links.map((link) => {
        const hasChildren = link.childLinks && link.childLinks.length > 0;
        const isOpen = openDropdowns.includes(link.name);

        return (
          <div key={link.href} className="w-full">
            {hasChildren ? (
              <div className="flex flex-col gap-2">
                <button
                  onClick={() => toggleDropdown(link.name)}
                  className="flex items-center gap-2 hover:text-primary hover:underline text-left w-full"
                  title={isCollapsed ? link.name : undefined}
                >
                  {link.icon && <link.icon className="size-5 shrink-0" />}
                  {!isCollapsed && <span>{link.name}</span>}
                </button>

                {/* Child links container */}
                {isOpen && !isCollapsed && (
                  <div className="flex flex-col gap-2 pl-4 ml-2 border-l border-border/50">
                    {link.childLinks.map((childLink: any, index: number) => (
                      <div key={childLink.href}>
                        <a
                          href={childLink.href}
                          className="flex items-center gap-2 hover:text-primary hover:underline text-sm"
                        >
                          {childLink.icon && (
                            <childLink.icon className="size-4 shrink-0" />
                          )}
                          <span>{childLink.name}</span>
                        </a>
                        {index !== link.childLinks.length - 1 && (
                          <div className="h-2" />
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Collapsed state - show tooltip on hover */}
                {isCollapsed && hasChildren && (
                  <div className="group relative">
                    <div className="hidden group-hover:block absolute left-full ml-2 top-0 min-w-50 z-50">
                      <div className="bg-background/95 backdrop-blur-sm border border-border rounded-md shadow-lg p-3">
                        <div className="font-semibold mb-2">{link.name}</div>
                        <div className="flex flex-col gap-2">
                          {link.childLinks.map((childLink: any) => (
                            <a
                              key={childLink.href}
                              href={childLink.href}
                              className="flex items-center gap-2 hover:text-primary hover:underline text-sm"
                            >
                              {childLink.icon && (
                                <childLink.icon className="size-4 shrink-0" />
                              )}
                              <span>{childLink.name}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <a
                href={link.href}
                className="flex items-center gap-2 hover:text-primary hover:underline w-full"
                title={isCollapsed ? link.name : undefined}
              >
                {link.icon && <link.icon className="size-5 shrink-0" />}
                {!isCollapsed && <span>{link.name}</span>}
              </a>
            )}
          </div>
        );
      })}
      <NavUtils isCollapsed={isCollapsed} />
    </div>
  );
}
